import React from 'react';
import { useValidateTier } from '../hooks/useTier';
import { Col } from 'react-bootstrap';
import { Help } from '../components/shared/Help';
import { Module } from '../components/tier/Module';
import { useIbv } from '../hooks/useIbvDialog';
import { useSelector } from 'react-redux';

import { useHideMenu } from '../hooks/useHelpMenu';

/**
 * Page tier
 * @returns {JSX}
 */
const TierPage = () => {
  useValidateTier();
  const { isIBVVerified, isIBVShown, setAlert } = useIbv();
  const { autoLoginURL } = useSelector(state => state.base);
  const { showHelperInfo } = useHideMenu({isIBVShown, autoLoginURL});



  return (
    <>        
      <Col className="p-0" xl={3} md={4} xs={12}>
        <Help 
          backButton={false} 
          show={showHelperInfo}
        />
      </Col>
      <Col className="p-4" xl={9} md={8} xs={12}>
        <Module 
          shouldShowIBV={isIBVShown && !isIBVVerified}
          setAlert={setAlert}
        />
      </Col>
    </>
  );
};
export default TierPage;